import { createAction, props } from '@ngrx/store';
import { RfsSourcingResponse } from 'src/app/shared/components/global-banner/dto/rfs-sourcing-response.model';

export const updateRfsOutcomes = createAction(
    '[DeletedItemVendors] updateRfsOutcomes',
    props<{ rfsOutcomes: RfsSourcingResponse, deletedItemIdMappings: Map<number, {itemId: number, displayItemNumber: number}> }>()
);
export const clearDeletedItemVendorStore = createAction('[DeletedItemVendors] clearDeletedItemVendorStore');